import { makeStyles } from '@material-ui/core';

import { orange } from 'shared/styles/colors';

export default makeStyles({
  root: {
    height: 'auto',
    width: 'fit-content',
    padding: '0.125rem 0.625rem 0.125rem 0.5rem',
    gap: '0.25rem',
    color: orange[60],
    backgroundColor: orange[10],
  },
  icon: {
    width: '1rem',
    height: '1rem',
    margin: 0,
    fill: orange[60],
    // fontSize: '1rem',
  },
  label: {
    padding: 0,
    fontWeight: 600,
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
  },
});
